import * as React from "react";
const ProfileMenuIcon = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.54 8.31a2.46 2.46 0 1 0 0-4.92 2.46 2.46 0 0 0 0 4.92m-11.08 0a2.46 2.46 0 1 0 0-4.92 2.46 2.46 0 0 0 0 4.92m11.08 12.3a2.46 2.46 0 1 0 0-4.921 2.46 2.46 0 0 0 0 4.922m-11.08 0a2.46 2.46 0 1 0 0-4.92 2.46 2.46 0 0 0 0 4.92"
            stroke="#465050"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ProfileMenuIcon;
